import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { CHANNEL_TYPES } from '@bingads-webui-campaign/recommendation-core';

import bubbleImg from '../media/bubble.svg';

function renderLearnMore(i18n, text, channel) {
  return (<LearnMoreLink
    text={text}
    topic={channel === CHANNEL_TYPES.COMPETITION ? 'ext60027' : 'ext60029'}
    linkText={i18n.getString('Learn_more_link_text')}
  />);
}

export const EmptyView = ({
  i18n,
  scope,
  channel,
  viewAccountRecommendations,
  data,
  isOptimizationScoreOn,
  overallOptimizationScoreBar,
  isDismissedDataEmpty,
  newI18n,
  viewDismissedRecommendations,
  isDismissedTabEnabled,
}) => {
  const showOptimizationScoreEmptyView = (isOptimizationScoreOn
    && overallOptimizationScoreBar
    && (overallOptimizationScoreBar.Available === 0
      || _.isNull(overallOptimizationScoreBar.Available)));
  const title = showOptimizationScoreEmptyView
    ? i18n.getString(`Summary_Card_${scope.levelAt}_Level_Empty_Title_OptimizationScore`)
    : i18n.getString(`Summary_Card_${scope.levelAt}_Level_Empty_Title`);
  let titleContent = title;
  let subTitleContent = '';
  let actionText = '';

  let totalRecommendations = {
    types: 0,
    tally: 0,
  };
  if (data) {
    totalRecommendations = _.reduce(
      data.value,
      (memo, { RecommendationsCount }) => ({
        types: RecommendationsCount > 0 ?
          memo.types + 1 :
          memo.types,
        tally: memo.tally + RecommendationsCount,
      }),
      totalRecommendations
    );
  }

  if (
    channel === CHANNEL_TYPES.RECOMMENDATION
  ) {
    subTitleContent = totalRecommendations.types === 0 ?
      i18n.getString('Summary_Card_Empty_Details_Recommendations_Tab') :
      i18n.getString(`Summary_Card_${scope.levelAt}_Level_Empty_Details`);

    const actionKey = totalRecommendations.types === 1 ?
      'Summary_Card_Empty_Button_With_Count_Recommendations_Tab' :
      'Summary_Card_Empty_Button_With_Count_Recommendations_Tab_Multi';
    actionText = i18n.getString(actionKey, {
      count: totalRecommendations.types,
    });
    i18n.getString('Summary_Card_View_Recommendations_Multi_Recommendations_Tab');
  } else if (channel === CHANNEL_TYPES.MCCRECOMMENDATION) {
    subTitleContent = i18n.getString('Summary_Card_Empty_Details_Recommendations_Tab_MCC');
  } else {
    if (totalRecommendations.tally > 0 || scope.levelAt === levelAtConstant.ACCOUNT) {
      subTitleContent = i18n.getString(`Summary_Card_${scope.levelAt}_Level_Empty_Details`);
    }

    actionText = i18n.getString(`Summary_Card_${scope.levelAt}_Level_Empty_Button_With_Count`, {
      count: totalRecommendations.tally,
    });
  }

  let hasSubTitle = !_.isEmpty(subTitleContent);
  const hasAction =
    totalRecommendations.tally > 0 &&
    scope.levelAt !== levelAtConstant.ACCOUNT &&
    scope.levelAt !== levelAtConstant.CUSTOMER;

  if (!hasSubTitle) {
    titleContent = renderLearnMore(i18n, titleContent, channel);
  }

  if (isDismissedTabEnabled && !isDismissedDataEmpty) {
    hasSubTitle = false;
    if (scope.levelAt === levelAtConstant.ACCOUNT) {
      titleContent = newI18n.getString(_TL_('You still have dismissed recommendations for this account'));
    } else if (scope.levelAt === levelAtConstant.CAMPAIGN) {
      titleContent = newI18n.getString(_TL_('You still have dismissed recommendations for this campaign'));
    }
  }

  return (
    <div className="empty-filter-view">
      <div className="empty-icon">
        <img src={bubbleImg} alt={title} />
      </div>
      <div className="empty-details">
        <h1 className="empty-title type-bold">{titleContent}</h1>
        {hasSubTitle &&
          <h2 className="empty-sub-title">{renderLearnMore(i18n, subTitleContent, channel)}</h2>}
        <div className="buttons-container">
          {hasAction &&
            <div className="empty-buttons view-account-recommendations">
              <button type="button" className="btn-primary" onClick={viewAccountRecommendations}>
                {actionText}
              </button>
            </div>}
          {showOptimizationScoreEmptyView && isDismissedTabEnabled && !isDismissedDataEmpty &&
            <div className="empty-buttons view-dismissed-recommendations">
              <button type="button" className="btn-default" onClick={viewDismissedRecommendations}>
                {newI18n.getString(_TL_('Check dismissed recommendations'))}
              </button>
            </div>}
        </div>
      </div>
    </div>);
};

EmptyView.propTypes = {
  i18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  scope: PropTypes.shape({
    levelAt: PropTypes.string.isRequired,
  }).isRequired,
  viewAccountRecommendations: PropTypes.func,
  channel: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  isOptimizationScoreOn: PropTypes.bool,
  overallOptimizationScoreBar: PropTypes.shape({
    Available: PropTypes.number,
  }),
  isDismissedDataEmpty: PropTypes.bool,
  newI18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func,
  }),
  viewDismissedRecommendations: PropTypes.func,
  isDismissedTabEnabled: PropTypes.bool,
};

EmptyView.defaultProps = {
  viewAccountRecommendations: _.noop,
  data: null,
  isOptimizationScoreOn: false,
  overallOptimizationScoreBar: {},
  isDismissedDataEmpty: true,
  newI18n: {},
  isDismissedTabEnabled: false,
  viewDismissedRecommendations: _.noop,
};
